import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import { Dropdown, IDropdownOption, Label } from '@fluentui/react';
import {
    useGetOrganizationEntitlementsQuery
} from "../../store/endpoints/OrganizationsEndpoints";

interface IStorefrontDomainDropdownProps {
    value?: string;
    onChange: (value: string) => void;
    emptyLabel?: string;
    label?: string;
}

const StorefrontDomainDropdown: React.FC<IStorefrontDomainDropdownProps> = (props) => {
    const organization = useSelector((state: RootState) => state.settings.selectedOrganization);
    const getOrg = useGetOrganizationEntitlementsQuery(organization ?? '', {skip: !organization || organization === ''});
    const [domains, setDomains] = React.useState<IDropdownOption[]>([]);

    React.useEffect(() => {
        if (getOrg.data) {
            const availableDomains = getOrg.data.storefrontDomains?.map(domain => ({key: domain, text: domain}))
            setDomains([
                { key: '', text: props.emptyLabel ?? 'Default' },
                ...availableDomains,
            ]);
        }
    }, [getOrg.data]);

    if (domains.length <= 2) return null; // 2 because of the default option

    return <div>
        <Label>{props.label}</Label>
        <Dropdown
            selectedKey={props.value}
            onChange={(e, item) => props.onChange(item?.key as string)}
            options={domains}
            placeholder={props.emptyLabel}
        />
    </div>
}

export default StorefrontDomainDropdown;